/*  eslint-disable react/prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col } from '@app/ui';
import classNames from '@app/ui/sports-components/utils/classNames';
import { useDraggable } from '@dnd-kit/core';

const cardBodyStyles = { body: { padding: 0 } };

const renderSponsorCardContent = ({
    sp,
    imgUrl,
    hasLogo,
    isDragDisabled,
    backgroundColor,
    useLegacyCardShell = false,
}) => {
    const inner = (
        <div className="gds-flex gds-flex--align-center gds-text--body-sm -p-a-2">
            {!isDragDisabled && (
                <i className="fas fa-ellipsis-v" aria-hidden="true" />
            )}
            <div className="gds-sponsors__image -m-l-1 -m-r-2 -color-bg-white -cursor--pointer">
                {hasLogo && (
                    <img src={imgUrl} height="100%" width="100%" alt="" />
                )}
                {!hasLogo && (
                    <div className="gds-flex gds-flex--justify-center gds-flex--content-center gds-flex-grid__item--full-height">
                        <i className="fa fa-fw fa-exclamation-triangle gds-text--danger" />
                    </div>
                )}
            </div>
            <div className="gds-sponsor__name">
                <p className="gds-text--body-sm gds-text--regular -ellipsis -p-r-1">
                    {sp.name}
                </p>
            </div>
        </div>
    );

    if (useLegacyCardShell) {
        return (
            <div className="gds-card" style={{ backgroundColor }}>
                {inner}
            </div>
        );
    }

    return (
        <Card style={{ backgroundColor }} styles={cardBodyStyles}>
            {inner}
        </Card>
    );
};

const DraggableSponsor = ({
    id,
    onclick,
    sponsor: sp,
    selectedSponsorPlacements,
    isDragDisabled,
}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        isDragging: isDraggingLocal,
    } = useDraggable({
        id,
        disabled: isDragDisabled,
    });

    const isSelected =
        selectedSponsorPlacements.findIndex(s => s.id === sp.id) > -1;
    const backgroundColor = isSelected && !isDraggingLocal ? '#EDFAFD' : null;

    const hasLogo = sp.logos && sp.logos.length > 0;
    const imgUrl = hasLogo ? sp.logos[0].url : null;

    const style = isDraggingLocal
        ? {
              opacity: 0,
              userSelect: 'none',
          }
        : transform
          ? {
                transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
                userSelect: 'none',
            }
          : { userSelect: 'none' };

    const numberOfSponsor = 1;

    const sponsorClassNames = classNames('gds-sponsor', {
        isSelected: isSelected,
    });

    const cardContentProps = {
        sp,
        imgUrl,
        hasLogo,
        isDragDisabled,
        backgroundColor,
    };

    // Col must be a direct Row child for the Ant Design 24-col grid.
    // Keep dnd-kit refs/listeners on an inner full-width node.
    return (
        <Col md={12}>
            <div
                onClick={onclick(isSelected)}
                ref={setNodeRef}
                {...attributes}
                {...listeners}
                style={style}
            >
                {(!isDraggingLocal || numberOfSponsor <= 1) && (
                    <div className={sponsorClassNames}>
                        {renderSponsorCardContent(cardContentProps)}
                    </div>
                )}
                {isDraggingLocal && numberOfSponsor > 1 && (
                    <div className="gds-sponsor--stacked">
                        <div className="gds-sponsor gds-sponsor--bottom">
                            {renderSponsorCardContent({
                                ...cardContentProps,
                                useLegacyCardShell: true,
                            })}
                        </div>
                        <div className="gds-sponsor gds-sponsor--top">
                            <span className="-abs-t-r gds-number-circle gds-number-circle--xs -m-r-0 -color-bg-pri -color-tx-white -z-1 -pointer-events--none">
                                {numberOfSponsor}
                            </span>
                            {renderSponsorCardContent({
                                ...cardContentProps,
                                useLegacyCardShell: true,
                            })}
                        </div>
                    </div>
                )}
            </div>
        </Col>
    );
};

DraggableSponsor.propTypes = {
    onclick: PropTypes.func,
    providedDraggable: PropTypes.object,
    snapshot: PropTypes.object,
    sponsor: PropTypes.object,
    selectedSponsorPlacements: PropTypes.array,
    isDragDisabled: PropTypes.bool,
    showDraggableItem: PropTypes.bool,
};

export default DraggableSponsor;
